import { Controller } from '@hotwired/stimulus';
import 'js-loading-overlay';

export default class extends Controller {
  static targets = ['frame', 'loading', 'stream'];
  static values = { url: String };

  connect() {
    // Re-read after subscribing (and reconnecting) so a broadcast sent between
    // the initial render and the subscription cannot leave the page waiting.
    this.observer = new MutationObserver(() => {
      if (this.streamTarget.hasAttribute('connected')) {
        this.refresh();
      }
    });
    this.observer.observe(this.streamTarget, {
      attributes: true,
      attributeFilter: ['connected'],
    });
    if (this.streamTarget.hasAttribute('connected')) {
      this.refresh();
    }
  }

  disconnect() {
    this.observer.disconnect();
    JsLoadingOverlay.hide();
  }

  loadingTargetConnected() {
    JsLoadingOverlay.show({
      spinnerIcon: 'ball-clip-rotate-multiple',
      spinnerSize: '1x',
    });
  }

  loadingTargetDisconnected() {
    JsLoadingOverlay.hide();
  }

  refresh() {
    if (!this.hasLoadingTarget) return;

    if (this.frameTarget.src) {
      this.frameTarget.reload();
    } else {
      this.frameTarget.src = this.urlValue;
    }
  }
}
